export default __webpack_public_path__ + "static/media/cover-3.db208773.webp";